<template>
  <div class="insured-form-container">
    <Panel title="1.ข้อมูลของผู้ขอเอาประกันภัย">
      <div class="customer-inquiry-section row">
        <div class="form-group col-sm-5">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">ประเภทบัตร</span>
            <Dropdown
              class="form-control input-sm"
              :options="identityOptions"
              v-model="customerIdentity.type"
              :selectedValue="customerIdentity.type"
              :disabled="disabledForm || checkDisabledCustomerIdentitySection()"
            />
          </div>
        </div>
        <div class="form-group col-sm-7">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg tx-card-rm">{{ renderIdentityText() }}</span>
            <input
              type="text"
              class="form-control input-sm"
              :class="{
                'bd-red': errors.has('identityNumber') || !verifyCitizen(),
              }"
              :maxlength="customerIdentity.type === 'idCard' ? 13 : ''"
              name="card_id"
              v-model="customerIdentity.number"
              :disabled="disabledForm || checkDisabledCustomerIdentitySection()"
            />
          </div>
        </div>
        <div class="customer-inquiry-btn-container text-center">
          <Button
            class="btn-dark btn-s-xs"
            type="info"
            data-type="amlo-pass"
            @click.native="triggerGetCustomerInquiry"
            :disabled="disabledForm || checkDisabledCustomerIdentitySection()"
          >
            <i class="fa fa-search"></i> ค้นหา
          </Button>
        </div>
      </div>
      <div class="customer-check-amlo-section row">
        <div class="form-insured-name-section clearfix">
          <div id="input-title" class="form-group col-sm-3">
            <div id="prefix-name" class="input-group">
              <div class="no-rm-error-box">
                <NoRmMessageLabel :is-rm-requested="isRmRequested" :is-rm-found="isRmFound">
                  ไม่พบข้อมูล RM กรุณากรอกข้อมูลผู้ขอเอาประกันภัย
                </NoRmMessageLabel>
              </div>
              <span class="input-group-addon nobd-nobg">คำนำหน้าชื่อ</span>
              <div v-if="isDisabledEditField()">
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model="customerInformation.namePrefix"
                  disabled
                />
              </div>
              <div v-else>
                <TitleNameSelect v-model="manualInfo.title" :disabled="disabledForm" />
              </div>
            </div>
          </div>
          <div id="input-firstname" class="form-group col-sm-4">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">ชื่อ</span>
              <div v-if="isDisabledEditField()">
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model="customerInformation.firstname"
                  disabled
                />
              </div>
              <div v-else>
                <TextInput
                  id="manual-input-firstname"
                  :text-only="true"
                  :disabled="disabledForm"
                  v-model="manualInfo.firstname"
                />
              </div>
            </div>
          </div>
          <div id="input-lastname" class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">นามสกุล</span>
              <div v-if="isDisabledEditField()">
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model="customerInformation.lastname"
                  disabled
                />
              </div>
              <div v-else>
                <TextInput
                  id="manual-input-lastname"
                  :text-only="true"
                  :disabled="disabledForm"
                  v-model="manualInfo.lastname"
                />
              </div>
            </div>
          </div>
        </div>
        <div id="input-birthdate" class="form-insured-dob-section clearfix">
          <div class="form-group col-sm-7">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">วัน/เดือน/ปีเกิด (พ.ศ.)</span>
              <div v-if="isDisabledEditField()">
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model="customerInformation.dob"
                  disabled
                />
              </div>
              <div v-else>
                <DatePicker
                  inputClass="form-control input-sm"
                  :buddhist="true"
                  :disabled="disabledForm"
                  v-model="manualInfo.birthdate"
                />
              </div>
            </div>
          </div>
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อายุ</span>
              <div v-if="isDisabledEditField()">
                <span class="h6 m-l m-t-xs text-primary"> {{ customerInformation.age }} ปี </span>
                <span class="h6 m-l m-t-xs text-primary" v-if="customerInformation.ageMonth">
                  {{ customerInformation.ageMonth }} เดือน
                </span>
              </div>
              <div v-else>
                <AgeLabel :birthdate="manualInfo.birthdate" />
              </div>
            </div>
          </div>
        </div>
        <div class="form-insured-contact-section clearfix">
          <div id="input-email" class="email-form-group form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อีเมล</span>
              <div v-if="isDisabledEditField()">
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model="customerInformation.email"
                  disabled
                />
              </div>
              <div v-else>
                <EmailInput
                  id="manual-input-email"
                  :to-upper="true"
                  :disabled="disabledForm"
                  v-model="manualInfo.email"
                />
              </div>
            </div>
          </div>
          <div id="input-mobile" class="phone-form-group form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">โทรศัพท์มือถือ</span>
              <div v-if="isDisabledEditField()">
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model="customerInformation.phone"
                  disabled
                />
              </div>
              <div v-else>
                <MobileInput
                  id="manual-input-mobile"
                  :disabled="disabledForm"
                  v-model="manualInfo.mobile"
                />
              </div>
            </div>
            <div class="warning-text">
              “หากท่านระบุเบอร์โทรศัพท์มือถือไม่ถูกต้อง
              จะไม่สามารถทำการชำระเงินด้วยวิธีการหักผ่านบัญชี ttb ได้”
            </div>
          </div>
        </div>
        <div class="customer-check-amlo-btn-container text-center">
          <div v-if="!isRmRequested || isRmFound">
            <Button
              class="btn-dark btn-s-xs"
              :type="!isCheckAmloSuccess ? 'info' : isPassAmlo ? 'primary' : 'danger'"
              data-type="amlo-pass"
              @click.native="verifyAmlo"
              :disabled="disabledForm || checkDisabledCustomerInformationSection()"
            >
              <i
                class="fa"
                :class="{
                  'fa-search': !isCheckAmloSuccess,
                  'fa-check-circle-o': isCheckAmloSuccess && isPassAmlo,
                  'fa-times-circle-o': isCheckAmloSuccess && !isPassAmlo,
                }"
              />
              <span v-if="!isCheckAmloSuccess"> ตรวจสอบ AMLO</span>
              <span v-else>{{ isPassAmlo ? ' ผ่าน AMLO' : ' ไม่ผ่าน AMLO' }}</span>
            </Button>
          </div>
          <ManualVerifyAmloButton
            v-else
            id="button-manual-verify-amlo"
            :is-rm-requested="isRmRequested"
            :is-disable-check-amlo-btn="isDisableCheckAmlo"
            v-model="isManualVerifyAmlo"
          />
        </div>
      </div>
      <div class="line line-dashed line-lg" />
      <div class="customer-personal-information-section row">
        <div class="form-insured-personal-section clearfix">
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg"> ส่วนสูง </span>
              <div v-if="!isManualVerifyAmlo">
                <input
                  type="tel"
                  class="form-control input-sm"
                  :class="{ 'bd-red': errors.has('height') }"
                  maxlength="3"
                  v-model="personalInformation.height"
                  :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                />
              </div>
              <div v-else>
                <input
                  id="manual-input-height"
                  type="tel"
                  class="form-control input-sm"
                  maxlength="3"
                  :class="{ 'bd-red': errors.has('height') }"
                  :disabled="disabledForm"
                  v-model="manualInfo.height"
                />
              </div>
              <span class="input-group-addon">ซม.</span>
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg"> น้ำหนัก </span>
              <div v-if="!isManualVerifyAmlo">
                <input
                  type="tel"
                  class="form-control input-sm"
                  :class="{ 'bd-red': errors.has('weight') }"
                  maxlength="3"
                  v-model="personalInformation.weight"
                  :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                />
              </div>
              <div v-else>
                <input
                  id="manual-input-weight"
                  type="tel"
                  class="form-control input-sm"
                  maxlength="3"
                  :class="{ 'bd-red': errors.has('weight') }"
                  :disabled="disabledForm"
                  v-model="manualInfo.weight"
                />
              </div>
              <span class="input-group-addon">กก.</span>
            </div>
          </div>

          <div class="form-group col-sm-6">
            <div class="input-group" :class="{ 'bd-red': errors.has('gender') }">
              <span class="input-group-addon nobd-nobg"> เพศ </span>
              <div v-if="!isManualVerifyAmlo">
                <div class="col-md-3 col-xs-3">
                  <Radio
                    name="gender"
                    label="M"
                    v-model="personalInformation.gender"
                    :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                  >
                    ชาย
                  </Radio>
                </div>
                <div class="col-md-3 col-xs-3">
                  <Radio
                    name="gender"
                    label="F"
                    v-model="personalInformation.gender"
                    :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                  >
                    หญิง
                  </Radio>
                </div>
              </div>
              <div v-else>
                <div class="col-md-3 col-xs-3">
                  <Radio
                    id="manual-input-gender-m"
                    name="gender"
                    label="M"
                    v-model="manualInfo.gender"
                  >
                    ชาย
                  </Radio>
                </div>
                <div class="col-md-3 col-xs-3">
                  <Radio
                    id="manual-input-gender-f"
                    name="gender"
                    label="F"
                    v-model="manualInfo.gender"
                  >
                    หญิง
                  </Radio>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อาชีพ</span>
              <div v-if="!isManualVerifyAmlo">
                <Dropdown
                  class="form-control input-sm"
                  :class="{ 'bd-red': errors.has('occupation') }"
                  :options="occupationOptionsList"
                  v-model="personalInformation.occupation"
                  :selectedValue="personalInformation.occupation"
                  :disabled="disabledForm || checkDisabledPersonalInformationSection()"
                />
              </div>
              <div v-else>
                <Dropdown
                  class="form-control input-sm"
                  :class="{ 'bd-red': errors.has('occupation') }"
                  :options="occupationOptionsList"
                  :selectedValue="manualInfo.occupation"
                  :disabled="disabledForm"
                  v-model="manualInfo.occupation"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="verify-insured-status-btn-container text-center">
          <div v-if="isDisableCheckTviRisk">
            <Button
              class="btn-dark btn-s-xs"
              :type="!isValidateInformationSuccess ? 'info' : 'primary'"
              data-type="amlo-pass"
              @click.native="checkRiskTviInsurance"
              :disabled="disabledForm || checkDisabledPersonalInformationSection()"
            >
              <span v-if="!isValidateInformationSuccess">
                <i class="fa fa-search"></i> ตรวจสอบการรับประกันภัย
              </span>
              <span v-else> ผ่านการรับประกันภัย </span>
            </Button>
          </div>
          <div v-else>
            <Button
              id="manual-submit-check-risk-tvi-insurance"
              class="btn-dark btn-s-xs"
              type="info"
              @click.native="manualCheckRiskTviInsurance"
              :disabled="disabledForm"
            >
              <span v-if="!isManualCheckRiskTviInsurancePass">
                <i class="fa fa-search"></i> ตรวจสอบการรับประกันภัย
              </span>
              <span v-else> ผ่านการรับประกันภัย </span>
            </Button>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import Button from '@/components/Button'
import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'
import { identityNumberText, passportNumberText, validationRule } from '@/lib/global'
import {
  isAllowInsuredAge,
  validateBMI,
  validateCitizenNumber,
  validateOccupation,
} from '@/lib/services'
import TitleNameSelect from '@/components/Select/TitleNameSelect.vue'
import TextInput from '@/components/Input/TextInput.vue'
import EmailInput from '@/components/Input/EmailInput.vue'
import MobileInput from '@/components/Input/MobileInput.vue'
import ManualVerifyAmloButton from '@/components/Button/ManualVerifyAmloButton.vue'
import DatePicker from '@/components/DatePicker.vue'
import AgeLabel from '@/components/Label/AgeLabel.vue'
import moment from 'moment'
import NoRmMessageLabel from '@/components/Label/NoRmMessageLabel.vue'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

export default {
  name: 'InsuredForm',
  props: ['typeInsurance', 'quotationId', 'disabledForm'],
  data() {
    return {
      identityOptions: [
        {
          value: 'idCard',
          description: 'บัตรประจำตัวประชาชน',
        },
        {
          value: 'passport',
          description: 'เลขที่หนังสือเดินทาง',
        },
      ],
      occupationOptionsList: [],
      rules: {
        identityNumber: 'required|numeric|min:13|max:13',
        gender: 'required',
        occupation: 'required',
        height: 'required|numeric',
        weight: 'required|numeric',
      },
      errors: null,
      // Manual fill in customer info
      manualInfo: {
        title: '',
        firstname: '',
        lastname: '',
        birthdate: '',
        email: '',
        mobile: '',
        height: '',
        weight: '',
        gender: 'M',
        occupation: '',
      },
      isDisableCheckAmlo: true,
      isDisableCheckTviRisk: true,
      isManualVerifyAmlo: false,
      isManualCheckRiskTviInsurancePass: null,
    }
  },
  components: {
    NoRmMessageLabel,
    ManualVerifyAmloButton,
    Button,
    Dropdown,
    Panel,
    Radio,
    TitleNameSelect,
    TextInput,
    EmailInput,
    MobileInput,
    DatePicker,
    AgeLabel,
  },
  computed: {
    ...mapGetters(['occupationList']),
    ...mapQuotationFields({
      customerIdentity: 'insuredDetail.data.customerIdentity',
      customerInformation: 'insuredDetail.data.customerInformation',
      personalInformation: 'insuredDetail.data.personalInformation',
      isGetCustomerIdentitySuccess: 'insuredDetail.data.isGetCustomerIdentitySuccess',
      isCheckAmloSuccess: 'insuredDetail.data.isCheckAmloSuccess',
      isPassAmlo: 'insuredDetail.data.isPassAmlo',
      isValidateInformationSuccess: 'insuredDetail.data.isValidateInformationSuccess',
      isRmFound: 'insuredDetail.isRmFound',
      isRmRequested: 'insuredDetail.isRmRequested',
    }),
  },
  watch: {
    occupationList: {
      deep: true,
      handler(dataList) {
        const generateOptionsList = dataList.map((data) => ({
          value: data.id,
          description: data.name_th,
        }))
        this.occupationOptionsList = [
          {
            code: '',
            description: 'กรุณาเลือกอาชีพ',
          },
          ...generateOptionsList,
        ]
      },
    },
    'customerIdentity.type'(val) {
      this.customerIdentity.number = this.customerIdentity.number

      const { idCard, passport } = validationRule.customerIdentity

      const isIdCardType = val === 'idCard'
      this.rules.identityNumber = isIdCardType ? idCard : passport

      this.setRule()
    },
    'customerIdentity.number'(val) {
      if (val) {
        this.validator.validate('identityNumber', val)
      }
    },
    manualInfo: {
      deep: true,
      handler: function (val) {
        const isNotEmpty = (name) => val[name] !== ''
        const isNotIncludeNumeric = (name) => !/\d/g.test(val[name])
        const isEmail = (name) => /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(val[name])
        const isNumeric = (name) => /^[0-9]*$/g.test(val[name])
        const isEqual10 = (name) => val[name].length === 10
        const customerBasicInfoRules = [
          // firstname
          isNotEmpty('firstname'),
          isNotIncludeNumeric('firstname'),
          // lastname
          isNotEmpty('lastname'),
          isNotIncludeNumeric('lastname'),
          // birthdate
          isNotEmpty('birthdate'),
          // email
          isNotEmpty('email'),
          isEmail('email'),
          // mobile
          isNotEmpty('mobile'),
          isNumeric('mobile'),
          isEqual10('mobile'),
        ]
        const customerBioInfoRules = [
          // height
          isNotEmpty('height'),
          isNumeric('height'),
          // weight
          isNotEmpty('weight'),
          isNumeric('weight'),
          // occupation
          isNotEmpty('occupation'),
        ]
        this.isDisableCheckAmlo = !customerBasicInfoRules.every((i) => i === true)
        this.isDisableCheckTviRisk = !customerBioInfoRules.every((i) => i === true)
      },
    },
  },
  mounted() {
    this.getOccupationInformation()
  },
  methods: {
    ...mapActions([
      'getCustomerInquiryInformation',
      'checkCustomerAmlo',
      'checkRiskTvi',
      'checkRiskTviV2',
      'createNewQuotation',
      'getOccupationInformation',
    ]),
    renderIdentityText() {
      return this.customerIdentity.type === 'idCard' ? identityNumberText : passportNumberText
    },
    verifyCitizen() {
      const idNumber = this.customerIdentity.number

      if (this.customerIdentity.type === 'idCard' && idNumber) {
        return validateCitizenNumber(idNumber)
      }

      return true
    },
    checkDisabledCustomerIdentitySection() {
      return !!this.isGetCustomerIdentitySuccess
    },
    checkDisabledCustomerInformationSection() {
      return !!(!this.isGetCustomerIdentitySuccess || this.isCheckAmloSuccess)
    },
    checkDisabledPersonalInformationSection() {
      return !!(!this.isCheckAmloSuccess || this.isValidateInformationSuccess)
    },
    triggerGetCustomerInquiry() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number

      this.validator
        .validateAll({
          identityNumber: citizenId,
        })
        .then((validationResult) => {
          if (validationResult && this.verifyCitizen()) {
            this.getCustomerInquiryInformation({
              field: 'insuredDetail',
              cardType: cardPersonalType === 'idCard' ? 'CI' : 'PP',
              citizenId,
            })
          }
        })
    },
    verifyAmlo() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number

      this.checkCustomerAmlo({
        field: 'insuredDetail',
        cardType: cardPersonalType === 'idCard' ? 'CI' : 'PP',
        citizenId,
      })
    },
    checkRiskTviInsurance() {
      this.validator.validateAll(this.personalInformation).then((validationResult) => {
        if (validationResult) {
          const { type, number } = this.customerIdentity
          const { age, ageDay } = this.customerInformation
          const { weight, height, gender, occupation } = this.personalInformation

          const resultValidateBMI = validateBMI(weight, height, age)
          const resultValidateOccupation = validateOccupation(occupation, this.occupationList)
          const resultValidateInsuredAge = this.isAllowInsuredAge(age, ageDay)

          if (resultValidateBMI && resultValidateOccupation && resultValidateInsuredAge) {
            const checkHasQuotationId = () => {
              if (this.quotationId) {
                return { quotationId: this.quotationId }
              }

              return {}
            }

            const requestBody = {
              cardType: type === 'idCard' ? 'CI' : 'PP',
              citizenId: number,
              personalInformation: {
                weight,
                height,
                sex: gender,
                occupationId: occupation,
              },
            }

            const data = {
              ...checkHasQuotationId(),
              requestBody,
            }

            this.checkRiskTvi(data)
          } else {
            this.$swal({
              type: 'error',
              title: 'ขออภัย ข้อมูลของท่านไม่ตรงกับข้อกำหนดและเงื่อนไขของบริษัทประกันภัยไทยวิวัฒน์',
            }).then(() => (this.disabledForm = true))
          }
        }
      })
    },
    manualCheckRiskTviInsurance: function () {
      const {
        weight,
        height,
        occupation: occupationId,
        birthdate,
        gender: sex,
        firstname,
        lastname,
        email,
        mobile,
        title,
      } = this.manualInfo
      const { type, number } = this.customerIdentity
      const [dob, today] = [moment(birthdate), moment()]
      const age = today.diff(dob, 'years')
      const ageDay = today.diff(dob, 'days')
      // Set rules
      const isBmiPass = validateBMI(weight, height, age)
      const isOccupationPass = validateOccupation(occupationId, this.occupationList)
      const isAgePass = isAllowInsuredAge(age, ageDay)
      // Validation
      const rules = [isOccupationPass, isBmiPass, isAgePass].every((i) => i === true)
      // Handle events
      if (!rules) {
        this.$swal({
          type: 'error',
          title: 'ขออภัย ข้อมูลของท่านไม่ตรงกับข้อกำหนดและเงื่อนไขของบริษัทประกันภัยไทยวิวัฒน์',
        }).then(() => (this.disabledForm = true))
      } else {
        const checkHasQuotationId = () => {
          if (this.quotationId) {
            return { quotationId: this.quotationId }
          }
          return {}
        }
        const requestBody = {
          cardType: type === 'idCard' ? 'CI' : 'PP',
          citizenId: number,
          personalInformation: {
            weight,
            height,
            sex,
            occupationId,
            firstname,
            lastname,
            email,
            mobile,
            title,
            birthdate,
          },
        }
        const data = {
          ...checkHasQuotationId(),
          requestBody,
        }
        this.checkRiskTviV2(data)
      }
    },
    isAllowInsuredAge(ageYear, ageDay) {
      if (ageYear > 70) return false
      return !(ageYear <= 0 && ageDay < 30)
    },
    clearErrors() {
      this.errors.clear()
    },
    setRule() {
      this.validator = new Validator(this.rules)
      this.$set(this, 'errors', this.validator.errors)
    },
    isDisabledEditField() {
      return this.isRmRequested === false || this.isRmFound === true
    },
  },
  created() {
    this.setRule()
  },
}
</script>

<style lang="scss">
.checkbox,
.radio {
  margin-top: 0 !important;
}

.panel {
  &.panel-default {
    > .panel-heading {
      padding: 5px 20px 5px 12px !important;
    }
  }
}

.insured-form-container {
  .insured-form-panel-header {
    color: #000;
  }

  .customer-inquiry-section {
    margin-bottom: 32px;
  }

  .customer-check-amlo-section {
    margin-bottom: 24px;

    .form-insured-contact-section {
      .phone-form-group {
        .warning-text {
          color: #eb5757;
          font-size: 12px;
          line-height: 16px;
          margin-top: 8px;
          margin-left: 95px;
        }
      }
    }
  }

  .customer-personal-information-section {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}

.no-rm-error-box {
  position: absolute;
  width: 300px;
  top: -30px;
  left: 10px;
}
</style>
